import React, { useEffect, useMemo, useRef, useState } from 'react'

const LetsRead = () =>{
    const [letsReadUrl, setLetsReadUrl] = useState("https://www.letsreadasia.org/categories");
    const Abcd = () => useMemo(
    function LetsRead() {
        return (

            <>
                <div className="tt-widgetContent-tab-holder" style={{ height: "85.5vh" }}>
                    <iframe src={letsReadUrl} frameborder="0" style={{ height: "83.5vh", width: "100%", backgroundColor: "white" }}></iframe>
                </div>
            </>
        )
    },[])
return <Abcd/>
}

export default LetsRead
